
import { ConfigurationSvg, GroundContactSvg, OnboardScheduleSvg, SquareImportIcon } from "../../../../CommonComponents/svgs/Svgs"
import { ContactStation, DeploymentType } from "../../../types"
import { calculate_duration, get_formated_time } from "../../../utils"
import { BuildScheduleDropdownIcon, GenerateScheduleDropdownIcon, ImportScheduleDropdownIcon, ScheduleListViewicon, ScheduleViewIcon } from "./Svgs"

export const NavigationButton = [
    {
        label: 'Onboard Schedule',
        name: 'plan-onboard-schedule',
        used_by: ['OPERATE', 'SIMULATE', 'TRUETWIN_COMMAND_CENTER', 'VALIDATE'],
        icon: OnboardScheduleSvg
    },
    {
        label: 'Control Schedule',
        name: 'plan-control-schedule',
        used_by: [''],
        icon: GroundContactSvg
    },
    {
        label: 'Ground Contacts',
        name: 'plan-ground-contact',
        used_by: ['OPERATE', 'SIMULATE', 'TRUETWIN_COMMAND_CENTER', 'VALIDATE'],
        icon: GroundContactSvg
    },
    {
        label: 'Configuration',
        name: 'plan-security-configuration',
        used_by: ['OPERATE', 'TRUETWIN_COMMAND_CENTER', 'VALIDATE'],
        icon: ConfigurationSvg
    },
    //need for future use
    // {
    //     label: 'Ground Schedule',
    //     name: 'plan-ground-schedule',
    //     used_by: ['operate', 'simulation', 'summary'],
    //     icon: GroundContactScheduleSvg
    // },
    // {
    //     label: 'SubSystem Configuration',
    //     name: 'plan-subsystem-configuration',
    //     used_by: ['operate', 'simulation', 'summary'],
    //     icon: SubSystemConfigurationSvg
    // },
]

export const ScheduleViewButton = [
    {
        label: 'Task View',
        value: 'task_view',
        icon: ScheduleViewIcon
    },
    {
        label: 'Telecommand View',
        value: 'telecommand_view',
        icon: ScheduleListViewicon
    },
]

export const ScheduleMenu = [
    {
        label: 'Generate',
        value: 'Generate',
        icon: GenerateScheduleDropdownIcon
    },
    {
        label: 'Build',
        value: 'Build',
        icon: BuildScheduleDropdownIcon
    },
    {
        label: 'Import',
        value: 'Import',
        icon: SquareImportIcon
    },
]


export const get_navigator_button_by_dashboard = (scenarioType: DeploymentType) => {
    return NavigationButton?.filter(item => item.used_by.includes(scenarioType))
}


export const get_contact_pass_details = (contact_type: string, contact: ContactStation, current_time: number) => {
    const pass_details: {
        time: string;
        duration: string;
        remaining: string
    } = {
        time: '',
        duration: '',
        remaining: '00:00:00'
    }
    if (!contact) return pass_details
    if (contact_type === 'Ongoing') {
        pass_details.time = get_formated_time(contact?.['startTime'])
        pass_details.duration = calculate_duration(contact?.['startTime'], contact?.['endTime'])
        pass_details.remaining = get_remaining_time(current_time, contact?.['endTime'])
    } else if (contact_type === 'Upcoming') {
        pass_details.time = get_formated_time(contact?.['startTime'])
        pass_details.duration = calculate_duration(contact?.['startTime'], contact?.['endTime'])
        pass_details.remaining = get_remaining_time(current_time, contact?.['startTime'])
    } else if (contact_type === 'Previous') {
        pass_details.time = get_formated_time(contact?.['endTime'])
        pass_details.duration = calculate_duration(contact?.['startTime'], contact?.['endTime'])
        pass_details.remaining = '00:00:00'
    }
    return pass_details
}

export const get_remaining_time = (start_time: number, end_time: number) => {
    const remainingTime = (end_time * 1000) - (start_time * 1000)
    const hours = Math.floor(remainingTime / (1000 * 60 * 60));
    const minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);

    const paddedHours = hours.toString().padStart(2, '0');
    const paddedMinutes = minutes.toString().padStart(2, '0');
    const paddedSeconds = seconds.toString().padStart(2, '0');
    return paddedHours === '00' ? `${paddedMinutes}:${paddedSeconds}` : `${paddedHours}:${paddedMinutes}:${paddedSeconds}`;
}